export const DRAWER_WIDTH = 260;

export const DRAWER_KEYS = {
  CUSTOMER: 'CUSTOMER',
  EXIT: 'EXIT',
  FINANCIAL: 'FINANCIAL',
  BILLING: 'BILLING',
  FINANCIAL_CONFIG: 'FINANCIAL_CONFIG',
  PLANS: 'PLANS',
  FILTERS: 'FILTERS',
  FILTERS_MANAGE: 'FILTERS_MANAGE',
  FILTERS_LIST: 'FILTERS_LIST',
  PRODUCTS: 'PRODUCTS',
  NOTIFICATIONS: 'NOTIFICATIONS',
  LOG: 'LOG',
  NONE: 'NONE'
}